<template>
    <div id="config-tags">
        <FilterView placeholder="Chercher un attribut..." v-model="searchTerm">
            <CustomButton
                v-if="selected.length"
                icon="trash-alt"
                class="default red-theme"
                @click="showConfirmMany = true"
            >
                Supprimer
            </CustomButton>
            <CustomButton icon="plus" class="default green-theme" @click="handleNew">
                Ajouter un attribut
            </CustomButton>
        </FilterView>
        <Modal v-if="showEdit" v-model="tag" @dismiss="showEdit = false" @close="handleClose" />
        <Confirm v-if="showConfirmOne" @dismiss="showConfirmOne = false" @close="handleDeleteOne">
            <span slot="header">Supprimer l'attribut</span>
            <span slot="body">
                Êtes-vous sûr de vouloir supprimer cet attribut ?<br />
                Attention, les références à cet attribut dans les groupes d'objets et les droits de
                validation seront également supprimées.
            </span>
        </Confirm>
        <Confirm
            v-if="showConfirmMany"
            @dismiss="showConfirmMany = false"
            @close="handleDeleteMany"
        >
            <span slot="header">
                Supprimer {{ selected.length }} {{ selected.length > 1 ? 'attributs' : 'attribut' }}
            </span>
            <span slot="body">
                Êtes-vous sûr de vouloir supprimer les attributs sélectionnés ?<br />
                Attention, les références à ces attributs dans les groupes d'objets et les droits de
                validation seront également supprimées.
            </span>
        </Confirm>
        <h2 class="title">Attributs</h2>
        <LoadingDots v-if="isLoading" />
        <CardPager>
            <TagCard
                v-for="item in filtered"
                :item="item"
                :key="item.id"
                :handleEdit="handleEdit"
                :handleConfirm="handleConfirm"
                :selected="selected"
                @selected="handleSelect"
            />
        </CardPager>
    </div>
</template>

<script>
import FilterView from '@/components/config/Filter';
import Modal from '@/components/config/ModalTag';
import Confirm from '@/components/config/DeleteConfirm';
import CustomButton from '@/components/Button';
import LoadingDots from '@/components/LoadingDots';
import CardPager from '@/components/CardPager';
import TagCard from '@/components/config/TagCard';

export default {
    data() {
        return {
            showEdit: false,
            showConfirmOne: false,
            showConfirmMany: false,
            tags: [],
            tag: null,
            searchTerm: null,
            isLoading: true,
            selected: [],
        };
    },
    computed: {
        filtered() {
            if (this.searchTerm) {
                const re = new RegExp(this.searchTerm, 'i');
                return this.tags.filter((t) => re.test(t.name) || re.test(t.name_fr));
            }
            return this.tags;
        },
    },
    mounted() {
        this.$http.get('/api/tag').then(
            (response) => {
                // success callback
                this.tags = response.body;
                this.isLoading = false;
            },
            (response) => {
                // error callback
                console.log(JSON.stringify(response));
                this.isLoading = false;
            },
        );
    },
    methods: {
        _getTag(id) {
            const tag = this.tags.find((t) => t.id === id);
            return {
                ...tag,
            };
        },
        handleSelect(event) {
            const { id, checked } = event;
            const index = this.selected.findIndex((s) => s === id);
            if (checked) {
                if (index === -1) {
                    this.selected.push(id);
                }
            } else {
                if (index > -1) {
                    this.selected.splice(index, 1);
                }
            }
        },
        handleConfirm(item) {
            this.tag = this._getTag(item);
            this.showConfirmOne = true;
        },
        handleEdit(item) {
            this.tag = this._getTag(item);
            this.showEdit = true;
        },
        handleClose() {
            // Crée le nouveau tag, si le nom du tag est renseigné
            if (!this.tag.id && this.tag.name) {
                this.$http
                    .post('/api/tag', this.tag)
                    .then(() => {
                        this.showEdit = false;
                        this.tag = null;
                        this.isLoading = true;
                        this.$http
                            .get('/api/tag')
                            .then(
                                (response) => {
                                    // success callback
                                    this.tags = response.body;
                                },
                                (response) => {
                                    // error callback
                                    console.log(JSON.stringify(response));
                                },
                            )
                            .finally(() => (this.isLoading = false));
                    })
                    .catch();
                // Met à jour le tag, si le nom du tag est renseigné
            } else if (this.tag.id && this.tag.name) {
                this.$http
                    .put(`/api/tag/${this.tag.id}`, this.tag)
                    .then((response) => {
                        const tag = response.body;
                        const index = this.tags.findIndex((t) => t.id === tag.id);
                        this.tags.splice(index, 1, tag);
                        this.showEdit = false;
                        this.tag = null;
                    })
                    .catch();
            }
        },
        handleNew() {
            this.tag = {
                id: null,
                name: '',
                name_fr: '',
            };
            this.showEdit = true;
        },
        handleDeleteOne() {
            this.$http
                .delete(`/api/tag/${this.tag.id}`)
                .then(() => {
                    const index = this.tags.findIndex((t) => t.id === this.tag.id);
                    this.tags.splice(index, 1);
                    this.showConfirmOne = false;
                    this.tag = null;
                })
                .catch();
        },
        handleDeleteMany() {
            const requests = this.selected.map((s) => this.$http.delete(`/api/tag/${s}`));
            Promise.all(requests)
                .then(() => {
                    this.showConfirmMany = false;
                    this.selected.splice(0);
                    this.isLoading = true;
                    return this.$http.get('/api/tag');
                })
                .then((response) => {
                    // success callback
                    this.tags = response.body;
                })
                .catch(() => {})
                .finally(() => (this.isLoading = false));
        },
    },
    components: {
        Modal,
        Confirm,
        CustomButton,
        FilterView,
        LoadingDots,
        CardPager,
        TagCard,
    },
};
</script>

<style lang="scss"></style>
